import React from 'react';
import { AnimatePresence } from 'motion/react';
import ProjectSidebar from '../ProjectSidebar';
import PeopleSidebar from '../PeopleSidebar';
import FilterBar from '../FilterBar';
import SubHeader from '../SubHeader';

export interface AppSubHeaderAndSidebarsProps {
  viewMode: string;
  isProjectView: boolean;
  isConceptView: boolean;
  isStandardTaskView: boolean;
  isProjectEditor: boolean;
  viewTabsState: any;
  dropdownProjects: any[];
  globalAllAssignees: string[];
  globalAvailableTypes: string[];
  globalAvailableStatuses: string[];
  toolsDropdownRef: React.RefObject<HTMLDivElement | null>;
  isFilterActive: boolean;
  zoomToFit: () => void;
  isFitMode: boolean;
  setAiAssistantTab: (tab: any) => void;
  workspaceProjects: any[];
  showFilters: boolean;
  isRightSidebarOpen: boolean;
  isSidebarCollapsed: boolean;
  sidebarPeople: string[];
  sidebarPeopleData: Map<string, any>;
  activeDragId: string | number | null;
  droppedZoneId: string | null;
  filterAssignee: string;
  peopleWithActiveVorgang: Set<string>;
  handleToggleSidebarPersonFilter: (person: string) => void;
  handleOpenSidebarContactCard: (person: string) => void;
  handleClearAssigneeFilter: () => void;
  handleAddPersonToProject: () => void;
}

export const AppSubHeaderAndSidebars: React.FC<AppSubHeaderAndSidebarsProps> = ({
  viewMode,
  isProjectView,
  isConceptView,
  isStandardTaskView,
  isProjectEditor,
  viewTabsState,
  dropdownProjects,
  globalAllAssignees,
  globalAvailableTypes,
  globalAvailableStatuses,
  toolsDropdownRef,
  isFilterActive,
  zoomToFit,
  isFitMode,
  setAiAssistantTab,
  workspaceProjects,
  showFilters,
  isRightSidebarOpen,
  isSidebarCollapsed,
  sidebarPeople,
  sidebarPeopleData,
  activeDragId,
  droppedZoneId,
  filterAssignee,
  peopleWithActiveVorgang,
  handleToggleSidebarPersonFilter,
  handleOpenSidebarContactCard,
  handleClearAssigneeFilter,
  handleAddPersonToProject,
}) => {
  return (
    <>
      <AnimatePresence>
        {(isProjectView ||
          isConceptView ||
          [
            'dashboard',
            'globalCalendar',
            'globalKanban',
            'communication',
            'analysis',
            'impactEffort',
            'metricsDashboard',
            'aiAssistant',
            'projectPool',
            'globalGantt',
          ].includes(viewMode)) && (
          <SubHeader
            {...viewTabsState}
            isReadOnly={!isProjectEditor}
            onToggleUiMode={viewTabsState.handleToggleUiMode}
            setActiveMetricsTab={viewTabsState.setActiveMetricsTabWithTransition}
            setActivePoolTab={viewTabsState.setActivePoolTabWithTransition}
            onShowBiography={viewTabsState.handleShowBiography}
            onShowTimeMachine={viewTabsState.handleShowTimeMachine}
            onActiveTabChange={viewTabsState.setActiveProjectTabWithTransition}
            dropdownProjects={dropdownProjects}
            isStandardTaskView={isStandardTaskView}
            isProjectView={isProjectView}
            setViewMode={viewTabsState.setViewModeWithTransition}
            globalAllAssignees={globalAllAssignees}
            globalAvailableTypes={globalAvailableTypes}
            globalAvailableStatuses={globalAvailableStatuses}
            toolsDropdownRef={toolsDropdownRef}
            isFilterActive={isFilterActive}
            onZoomToFit={zoomToFit}
            isZoomedToFit={isFitMode}
            setActiveAITab={setAiAssistantTab}
            workspaceProjects={workspaceProjects}
            onPrefetch={viewTabsState.handlePrefetchView}
          />
        )}
      </AnimatePresence>

      <FilterBar
        show={showFilters && !['globalKanban', 'analysis', 'communication'].includes(viewMode)}
        topOffset={isProjectView || viewMode === 'globalGantt' ? 64 + 52 : 64}
        isRightSidebarOpen={isRightSidebarOpen}
      />

      {/* Left Project Sidebar */}
      <aside
        className="fixed left-0 bottom-0 z-[45] bg-white dark:bg-slate-900 border-r border-slate-200/80 dark:border-slate-800/40 transition-all duration-300 flex flex-col overflow-visible print:hidden"
        style={{ width: isSidebarCollapsed ? '80px' : '320px', top: '64px' }}
      >
        <ProjectSidebar />
      </aside>

      {/* Right People Sidebar */}
      <aside
        className="fixed right-0 bottom-0 z-[45] bg-slate-955 border-l border-white/5 transition-all duration-300 flex flex-col overflow-visible print:hidden"
        style={{
          width: isRightSidebarOpen ? '80px' : '0px',
          top: '64px',
          transform: isRightSidebarOpen ? 'translateX(0)' : 'translateX(100%)',
          opacity: isRightSidebarOpen ? 1 : 0,
          pointerEvents: isRightSidebarOpen ? 'auto' : 'none',
        }}
      >
        <PeopleSidebar
          people={sidebarPeople}
          peopleData={sidebarPeopleData}
          activeDragId={activeDragId}
          droppedZoneId={droppedZoneId}
          filterAssignee={filterAssignee}
          activeVorgangNames={peopleWithActiveVorgang}
          onToggleFilter={handleToggleSidebarPersonFilter}
          onOpenContactCard={handleOpenSidebarContactCard}
          onClearFilter={handleClearAssigneeFilter}
          onAddPerson={handleAddPersonToProject}
        />
      </aside>
    </>
  );
};
